export default "__VITE_ASSET__B6OYIx$j__"